import { render } from "./ArticleAnchors.vue?vue&type=template&id=4d0f0cc6"
import script from "./ArticleAnchors.vue?vue&type=script&lang=js"
export * from "./ArticleAnchors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__